import type { App } from 'vue'

import { createI18n } from 'vue-i18n'

import en from './en.json'
import recommendationsEn from './recommendations/en.json'
import recommendationsZh from './recommendations/zh.json'
import zh from './zh.json'

const mergedEn = { ...en, recommendations: recommendationsEn }
const mergedZh = { ...zh, recommendations: recommendationsZh }

// 检测用户语言偏好
function detectLocale(): string {
  // 1. 首先检查localStorage中保存的语言设置
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && ['en', 'zh'].includes(savedLocale)) {
    return savedLocale
  }

  // 2. 检查浏览器语言
  // const browserLanguage = navigator.language.toLowerCase()
  // if (browserLanguage.startsWith('zh')) {
  //   return 'zh'
  // }

  // 3. 默认使用英文
  return 'en'
}

export function setupI18n(app: App) {
  const i18n = createI18n({
    legacy: false,
    locale: detectLocale(),
    fallbackLocale: 'en',
    messages: {
      zh: mergedZh,
      en: mergedEn,
    },
  })
  app.use(i18n)

  // Set HTML lang attribute for accessibility
  if (typeof document !== 'undefined') {
    document.documentElement.lang = i18n.global.locale.value
  }

  return i18n
}
